<template>
  <div class="signup-success">
    <CustomLottie :animationData="animationData"></CustomLottie>
    <h3>成功提交申請 (參考編號: {{ refId }})</h3>
    <p>所有批核需時2-5個工作天，成功審批後將收到電郵確認，謝謝！請保留參考編號以便日後查詢。</p>
    <b-button variant="primary"
              size="lg"
              href="https://www.ulifestyle.com.hk"
    >
      完成
    </b-button>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';
import CustomLottie from '@/components/CustomLottie.vue';
import animationData from '@/assets/lottie/form.json';

export default {
  components: {
    BButton,
    CustomLottie,
  },
  props: ['refId'],
  data: () => ({
    animationData,
  }),
  mounted() {
    this.$emit('updated');
  },
};
</script>

<style scoped lang="scss">
.signup-success {
  text-align: center;

  .lottie-container {
    margin-bottom: 24px;
  }

  h3 {
    font-size: 18px;
    color: #3A4047;
    margin-bottom: 12px;
  }

  p {
    color: #636D77;
    font-size: 15px;
    margin-bottom: 32px;
  }

  .btn-lg {
    width: 100%;
  }
}
</style>
